import styled from 'styled-components';

import { MedicationItem } from 'src/app/components/Pages/LoggedInTransfer/Experiment/Confirmation/styles';

export const GrayBox = styled.aside`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.space.s4};
  gap: ${({ theme }) => theme.space.s5};
  background-color: ${({ theme }) => theme.colors.capsuleGray00};
  border-radius: ${({ theme }) => theme.radii.r100};
  margin: ${({ theme }) => theme.space.s5} 0;
  ${({ theme }) => theme.mediaQueries.smallDown} {
    margin: ${({ theme }) => theme.space.s4} 0;
  }
`;

export const MedicationListContainer = styled.ul<{ bold?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.s3};
  width: 100%;
  ${props => !!props.bold && `font-weight: bold;`}
  ${MedicationItem} {
    margin-bottom: 0px;
  }
`;

export const MedSearchItem = styled.div<{ ineligible?: boolean }>`
  ${props =>
    !!props.ineligible &&
    `
    color: ${props.theme.colors.capsuleGray50};
  `}
`;
